"use strict";

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : new P(function (resolve) {
        resolve(result.value);
      }).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
    label: 0,
    sent: function sent() {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];

        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;

          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };

          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;

          case 7:
            op = _.ops.pop();

            _.trys.pop();

            continue;

          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }

            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }

            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }

            if (t && _.label < t[2]) {
              _.label = t[2];

              _.ops.push(op);

              break;
            }

            if (t[2]) _.ops.pop();

            _.trys.pop();

            continue;
        }

        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var app_1 = __importDefault(require("firebase/app"));

require("firebase/auth");

var XYAccount =
/** @class */
function () {
  function XYAccount(_onStateChange) {
    var config = {
      apiKey: "AIzaSyCCtXYmkLd3gh6fKjSCGOWhsYoeKccYq-g",
      authDomain: "xyo-network-1522800011804.firebaseapp.com",
      databaseURL: "https://xyo-network-1522800011804.firebaseio.com",
      projectId: "xyo-network-1522800011804",
      storageBucket: "xyo-network-1522800011804.appspot.com",
      messagingSenderId: "542704523793"
    };
    this.app = app_1.default.initializeApp(config);

    if (_onStateChange) {
      app_1.default.auth().onAuthStateChanged(_onStateChange);
    }
  }

  XYAccount.prototype.record = function (_event) {};

  XYAccount.prototype.currentUser = function () {
    return app_1.default.auth().currentUser;
  };

  XYAccount.prototype.sendPasswordResetEmail = function (email) {
    return __awaiter(this, void 0, void 0, function () {
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4
            /*yield*/
            , app_1.default.auth(this.app).sendPasswordResetEmail(email)];

          case 1:
            _a.sent();

            return [2
            /*return*/
            ];
        }
      });
    });
  };

  XYAccount.prototype.signUp = function (_email, _password) {
    return __awaiter(this, void 0, void 0, function () {
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4
            /*yield*/
            , app_1.default.auth().createUserWithEmailAndPassword(_email, _password)];

          case 1:
            _a.sent();

            return [2
            /*return*/
            ];
        }
      });
    });
  };

  XYAccount.prototype.signIn = function (_email, _password) {
    return __awaiter(this, void 0, void 0, function () {
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4
            /*yield*/
            , app_1.default.auth().signInWithEmailAndPassword(_email, _password)];

          case 1:
            _a.sent();

            return [2
            /*return*/
            ];
        }
      });
    });
  };

  XYAccount.prototype.signOut = function () {
    return __awaiter(this, void 0, void 0, function () {
      return __generator(this, function (_a) {
        return [2
        /*return*/
        , app_1.default.auth().signOut()];
      });
    });
  };

  XYAccount.prototype.updatePassword = function (_password) {
    return __awaiter(this, void 0, void 0, function () {
      var user;
      return __generator(this, function (_a) {
        user = this.currentUser();
        if (!user) throw new Error('No user found please login');
        return [2
        /*return*/
        , user.updatePassword(_password)];
      });
    });
  };

  XYAccount.prototype.signInWithFacebook = function () {
    return __awaiter(this, void 0, void 0, function () {
      var provider;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            provider = new app_1.default.auth.FacebookAuthProvider();
            return [4
            /*yield*/
            , app_1.default.auth().signInWithPopup(provider)];

          case 1:
            _a.sent();

            return [2
            /*return*/
            ];
        }
      });
    });
  };

  XYAccount.prototype.signInWithGoogle = function () {
    return __awaiter(this, void 0, void 0, function () {
      var provider;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            provider = new app_1.default.auth.GoogleAuthProvider();
            return [4
            /*yield*/
            , app_1.default.auth().signInWithPopup(provider)];

          case 1:
            _a.sent();

            return [2
            /*return*/
            ];
        }
      });
    });
  };

  XYAccount.prototype.isSignedIn = function () {
    return app_1.default.auth().currentUser != null;
  };

  return XYAccount;
}();

exports.default = XYAccount;